import { Button } from '../../components/Button';
import { Drawer } from '../../components/Drawer';
import { space } from '../../theme/tokens';
import { ItineraryView } from '../ItineraryView';
import { Body, Footer, Title } from './ItineraryDrawer.styles';
import type { ItineraryDrawerLabels, ItineraryDrawerProps } from './ItineraryDrawer.types';

const DEFAULT_LABELS: Required<ItineraryDrawerLabels> = {
  title: 'Your itinerary',
  closeLabel: 'Close itinerary',
  continueLabel: 'Continue planning',
  selectGuestLabel: 'Select guest',
};

const SMALL_LAYOUT_MAX_WIDTH = 400;

export function ItineraryDrawer({ open, onClose, guests, stay, labels }: ItineraryDrawerProps) {
  const resolvedLabels = { ...DEFAULT_LABELS, ...labels };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      aria-label={resolvedLabels.title}
      closeLabel={resolvedLabels.closeLabel}
      width="600px"
      mobileTopOffset={space['space-1000']}
      backdropBlur
      footer={
        <Footer>
          <Button type="button" variant="primary" size="large" fullWidth onClick={onClose}>
            {resolvedLabels.continueLabel}
          </Button>
        </Footer>
      }
    >
      <Body data-testid="itinerary-drawer">
        <Title>{resolvedLabels.title}</Title>
        <ItineraryView
          guests={guests}
          stay={stay}
          selectGuestLabel={resolvedLabels.selectGuestLabel}
          stackedDatesMaxWidth={SMALL_LAYOUT_MAX_WIDTH}
          smallTextMaxWidth={SMALL_LAYOUT_MAX_WIDTH}
          dateHeadingLevel="h3"
        />
      </Body>
    </Drawer>
  );
}
